module.exports = __webpack_public_path__ + "static/media/5DPO17.989e5fd5.jpg";